import { action } from 'satcheljs';
export var addCalendarItemsToStore = action('ADD_CALENDAR_ITEMS_TO_STORE', function (items) { return ({
    items: items,
}); });
export var refreshCalendarEvents = action('REFRESH_CALENDAR_EVENTS');
export var loadWeatherForecast = action('LOAD_WEATHER_FORECAST');
export var addWeatherDailyConditionsToStore = action('ADD_WEATHER_DAILY_CONDITIONS_TO_STORE', function (weatherForecastResponse) { return ({
    weatherForecastResponse: weatherForecastResponse,
}); });
export var hideAgenda = action('SET_IS_UPNEXT_AGENDA_OPEN');
export var toggleIsAgendaOpen = action('TOGGLE_IS_UPNEXT_AGENDA_OPEN');
export var startRefreshTimer = action('START_REFRESH_TIMER');
export var updateNextMeetingInformation = action('UPDATE_NEXT_MEETING_INFORMATION', function (nextMeeting) { return ({
    nextMeeting: nextMeeting,
}); });
//# sourceMappingURL=internalActions.js.map